module.exports = __webpack_public_path__ + "img/bowls.bcaba2f9.svg";